module.exports = __webpack_public_path__ + "static/media/user-icon.840278ca.svg";